import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { SEASONS } from '@app/activo2/manage-vacations/manage-vacations.constants';
import { ITitleDescription } from '@app/activo2/manage-vacations/manage-vacations.interface';
import { MotVacationsCriteria, VacationsSeason } from '@app/activo2/manage-vacations/manage-vacations.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-mot-criteria-step',
  templateUrl: './criteria-step.component.html',
  styleUrls: ['./criteria-step.component.scss']
})
export class CriteriaStepComponent implements OnInit {
  @Input() criteria!: MotVacationsCriteria;
  @Input() selectedSeason!: VacationsSeason;
  @Input() insideModal!: boolean;

  @Output() alternationGuideClicked = new EventEmitter<void>();

  mappedLastHolidays: ITitleDescription[] = [];
  mappedAlternationGuide: ITitleDescription[] = [];

  constructor(private translateService: TranslateService) {}

  get hasVacations() {
    return this.criteria.lastHolidays.winter.length || this.criteria.lastHolidays.summer.length;
  }

  get hasAlternationGuide() {
    return (
      (this.criteria.alternationGuide.winter.length && this.selectedSeason.id === SEASONS.winter) ||
      (this.criteria.alternationGuide.summer.length && this.selectedSeason.id === SEASONS.summer)
    );
  }

  ngOnInit() {
    if (this.criteria.lastHolidays.winter.length) {
      this.mappedLastHolidays.push({
        title: this.translateService.instant('MANAGE_VACATIONS.WINTER'),
        description: this.criteria.lastHolidays.winter
      });
    }

    if (this.criteria.lastHolidays.summer.length) {
      this.mappedLastHolidays.push({
        title: this.translateService.instant('MANAGE_VACATIONS.SUMMER'),
        description: this.criteria.lastHolidays.summer
      });
    }

    this.mappedAlternationGuide = [
      {
        title: this.translateService.instant(`MANAGE_VACATIONS.${this.selectedSeason.id.toUpperCase()}`),
        description: this.criteria.alternationGuide[this.selectedSeason.id].join('\n')
      }
    ];
  }

  onAlternationGuideClick() {
    this.alternationGuideClicked.emit();
  }
}
